import { api } from "../api";

export type FilterSet = {
  id: number;
  scope: string;
  name: string;
  query: Record<string, string>;
  is_global: boolean;
  is_mine: boolean;
  can_edit: boolean;
};

export type CreateFilterSetPayload = {
  scope: string;
  name: string;
  query: Record<string, string>;
  is_global?: boolean;
};

export type UpdateFilterSetPayload = Partial<
  Pick<CreateFilterSetPayload, "name" | "query" | "is_global">
>;

type FilterSetResponse = {
  data: FilterSet;
};

export type FilterSetListResponse = {
  data: FilterSet[];
  // Whether the caller may save/see a Shared (is_global) set (asana-995,
  // Task 10) -- the client must ask, not assume, since a consumer with no
  // `cruxtify-manage-global-filter-sets` Gate defined refuses a Shared save
  // with a bare 403.
  can_manage_global: boolean;
};

export const filterSetApi = {
  list: (scope: string): Promise<FilterSetListResponse> =>
    api
      .GET("filter-sets", { scope })
      .then((response: FilterSetListResponse) => response),

  create: (payload: CreateFilterSetPayload): Promise<FilterSet> =>
    api
      .POST("filter-sets", payload)
      .then((response: FilterSetResponse) => response.data),

  update: (
    id: number,
    payload: UpdateFilterSetPayload
  ): Promise<FilterSet> =>
    api
      .PUT(`filter-sets/${id}`, payload)
      .then((response: FilterSetResponse) => response.data),

  remove: (id: number): Promise<void> => api.DELETE(`filter-sets/${id}`),
};
